'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toToastContent(msg) {
    return _react2.default.createElement(
        'ul',
        { style: { textAlign: 'left' } },
        msg.map(function (o) {
            return _react2.default.createElement(
                'li',
                null,
                o
            );
        })
    );
}

exports.default = {
    toToastContent: toToastContent
};
module.exports = exports['default'];